import React from "react";
import { styled } from '@mui/material/styles';
import ctaStyles from './CTAStyles';
import Button from "../Button/Button";

type CTAProps = {
  title: string;
  description: string;
  buttonText: string;
};

const StyledCTA = styled('section')(({ theme }) => ctaStyles);

const CTA: React.FC<CTAProps> = ({ title, description, buttonText }) => (
  <div className="flex justify-center items-center bg-[#fdfdfd]">
    <StyledCTA className='flex justify-center items-center container leading-[3rem] md:leading-[unset] mx-8 lg:my-16 lg:mt-[10rem] lg:mb-[10rem] my-20 sm:px-16 px-6 lg:py-12 py-4 lg:flex-row flex-col rounded-[20px] box-shadow'>
      <div className="flex-1 flex flex-col">
        <h2 className='font-semibold xs:text-[48px] text-[25px] sm:text-[40px] text-black leading-[2.5rem] md:leading-[unset] w-full pt-10 sm:p-0'>{title}</h2>
        <p className='text-black font-normal text-dimWhite text-[18px] leading-[30.8px]  mt-5'>
          {description}
        </p>
      </div>
      <div className='flex justify-center items-center sm:ml-10 ml-0 sm:mt-0 mt-10'>
        <Button href="/contacto" className="hidden lg:inline-block">
          {buttonText}
        </Button>
      </div>
    </StyledCTA>
  </div>
);

export default CTA;